import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

/**
 * Minimal Card primitive used by the Results page sections. Wraps children
 * in a bordered, rounded container with the `--card` background. Designed
 * to stack vertically on the Results page.
 */
interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ style, children, ...rest }: CardProps) {
  const base: CSSProperties = {
    border: "1px solid var(--border)",
    borderRadius: 12,
    background: "var(--card)",
    color: "var(--card-foreground)",
  };
  return (
    <div {...rest} style={{ ...base, ...style }}>
      {children}
    </div>
  );
}
